"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _enviro = _interopRequireDefault(require("enviro"));

var propTypes = {
  currentUserEmail: _propTypes.default.string.isRequired,
  portalDomain: _propTypes.default.string.isRequired
};

var TimelineRequestElevatedEmailPermissionsCard =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TimelineRequestElevatedEmailPermissionsCard, _Component);

  function TimelineRequestElevatedEmailPermissionsCard() {
    (0, _classCallCheck2.default)(this, TimelineRequestElevatedEmailPermissionsCard);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineRequestElevatedEmailPermissionsCard).apply(this, arguments));
  }

  (0, _createClass2.default)(TimelineRequestElevatedEmailPermissionsCard, [{
    key: "getElevatedJITALink",
    value: function getElevatedJITALink() {
      return "https://tools.hubteam" + (_enviro.default.isProd() ? '' : 'qa') + ".com/login/jita?jitaType=ELEVATED&email=" + encodeURIComponent(this.props.currentUserEmail) + "&jitaDuration=60&loginPortalId=" + encodeURIComponent(_hubspot.default.get()) + "&loginPortalName=" + encodeURIComponent(this.props.portalDomain) + "&loginRedirectUrl=" + encodeURIComponent(window.location.href);
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      return _react.default.createElement("div", null, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
        message: "emailJITAPermissionsCard.title"
      })), _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "emailJITAPermissionsCard.description",
        className: "display-block"
      }), _react.default.createElement(_UIButton.default, {
        use: "tertiary-light",
        className: "m-top-4",
        href: this.getElevatedJITALink(),
        size: "sm"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "emailJITAPermissionsCard.requestElevatedAccessButton"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "p-all-8 display-flex justify-around align-center"
      }, _react.default.createElement(_UIIllustration.default, {
        name: "keys",
        className: "p-right-13",
        height: 150
      }), this.renderBody());
    }
  }]);
  return TimelineRequestElevatedEmailPermissionsCard;
}(_react.Component);

TimelineRequestElevatedEmailPermissionsCard.propTypes = propTypes;
var _default = TimelineRequestElevatedEmailPermissionsCard;
exports.default = _default;
module.exports = exports.default;